import React from 'react';
import { Helmet } from 'react-helmet-async';
import SiteWrapper from './home-pages/SiteWrapper';

const PageWrapper = ({ title, children }) => (
  <SiteWrapper>
    {title && (
      <Helmet>
        <title>{title}</title>
      </Helmet>
    )}
    {children}
  </SiteWrapper>
);

export default PageWrapper;
